import React from 'react';
import { isEmpty } from '../../utils/obj-utils';

export const getFormReferences = (formData) => {
    const formDataKeys = Object.keys(formData);

    return formDataKeys.reduce((acc, value) => {
        acc[value] = React.createRef();
        return acc;
    }, {});
};

export const scrollToInvalidField = (errors, formReferences) => {
    if (isEmpty(errors)) {
        return;
    }

    const errorKeys = Object.keys(errors);
    const fieldName = errorKeys.find((element) => {
        if (errors[element] === null || errors[element] === undefined) {
            return false;
        }

        return !errors[element].isValid;
    });

    let scrollToReference = formReferences[fieldName];

    if (isEmpty(scrollToReference.current)) {
        scrollToReference = Object.values(formReferences).find((formReference) => formReference.current !== null);
    }

    scrollToField(scrollToReference);
};

export const scrollToField = (field) => {
    if (field && field.current) {
        const destinationField = field.current.captcha ? field.current.captcha : field.current
        destinationField.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
        });
    }
};
